import React,{useState} from 'react';
import {Link} from 'react-router-dom';
import '../styles/Header.css';
import {useBranding} from '../branding/BrandingContext';

export default function Header(){

  const{theme}=useBranding();
  const isHome=true;
  const [menuOpen,setMenuOpen]=useState(false);

  const linkStyle={
    color:'#fff',
    textDecoration:'none',
    fontWeight:'600',
    transition:'0.25s'
  };

  return(

    <header
      className={isHome ? "axu-home-header" : undefined}
      style={{
        position:'sticky',
        top:0,
        zIndex:1000,
        background:'rgba(5,5,5,0.95)',
        backdropFilter:'blur(12px)',
        borderBottom:'1px solid rgba(127,0,255,.25)',
        padding:'16px 40px',
        display:'flex',
        justifyContent:'space-between',
        alignItems:'center'
      }}
    >

      <Link
        to="/"
        style={{
          display:'flex',
          alignItems:'center',
          gap:'12px',
          textDecoration:'none'
        }}
      >

        {theme?.logoURL ? (

          <img
            src={theme.logoURL}
            alt="AXU Workforce"
            style={{
              height:'44px'
            }}
          />

        ) : (

          <h2
            style={{
              margin:0,
              color:'#00ffff',
              fontWeight:'800'
            }}
          >
            AXU Workforce
          </h2>

        )}

      </Link>

      {isHome && <button
        className="axu-menu-toggle"
        type="button"
        aria-expanded={menuOpen}
        aria-controls="public-navigation"
        onClick={()=>setMenuOpen(open=>!open)}
      >{menuOpen ? 'Close menu' : 'Menu'} <span aria-hidden="true">{menuOpen ? '×' : '☰'}</span></button>}

      <nav
        id="public-navigation"
        aria-label="Main navigation"
        className={isHome && menuOpen ? "axu-nav-open" : undefined}
        onClick={()=>setMenuOpen(false)}
        style={{
          display:'flex',
          gap:'30px',
          alignItems:'center'
        }}
      >

        <Link
          to="/"
          style={linkStyle}
        >
          Home
        </Link>

        <Link to="/jobs" style={linkStyle}>Jobs</Link>

        <Link
          to="/services"
          style={linkStyle}
        >
          Services
        </Link>

        <Link
          to="/employer"
          style={linkStyle}
        >
          Employers
        </Link>

        <Link
          to="/quote"
          style={linkStyle}
        >
          Register for Work
        </Link>

        <Link
          to="/contact"
          style={linkStyle}
        >
          Contact
        </Link>

      </nav>

    </header>

  );

}